import { classNames } from "../utils";
import React from "react";

export const Headline = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames("text-gray-700 font-semibold text-xl", className)}
    >
      {children}
    </div>
  );
};

export const SubHeadline = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames("text-gray-600 text-lg font-normal", className)}>
      {children}
    </div>
  );
};
